import { render } from "./information.vue?vue&type=template&id=07897666&scoped=true"
import script from "./information.vue?vue&type=script&lang=js"
export * from "./information.vue?vue&type=script&lang=js"

import "./information.vue?vue&type=style&index=0&id=07897666&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07897666"],['__file',"src/views/components/information.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "07897666"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('07897666', __exports__)) {
    console.log('reload')
    api.reload('07897666', __exports__)
  }
  
  module.hot.accept("./information.vue?vue&type=template&id=07897666&scoped=true", () => {
    console.log('re-render')
    api.rerender('07897666', render)
  })

}


export default __exports__